// @ts-nocheck
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { addProductWithResult } from "@store/Framework/Services/CartService"; // Store Custom Code
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, SendDataToApi, async props => {
    const result = await addProductWithResult(props.apiParameter); // Store Custom Code
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
